import { render, staticRenderFns } from "./JustFilter.vue?vue&type=template&id=18f9259c"
import script from "./JustFilter.vue?vue&type=script&lang=js"
export * from "./JustFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports